import BaseKinesisEvent from './BaseKinesisEvent';

class LoginViewEvent extends BaseKinesisEvent {
  constructor() {
    super('login_view', 'login');
  }
}

export default LoginViewEvent;
